import React from "react";
import { useModalBackdropClose } from "../hooks/useModalBackdropClose";

export type ConfirmVariant = "primary" | "danger" | "warning";

export interface SMRTTasksConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: ConfirmVariant;
  isLoading?: boolean;
  error?: string | null;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export default function SMRTTasksConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  variant = "primary",
  isLoading = false,
  error = null,
  onClose,
  onConfirm,
}: SMRTTasksConfirmModalProps) {
  // Hook must come before the early return so the order stays stable.
  const backdrop = useModalBackdropClose(() => {
    if (isLoading) return;
    onClose();
  });

  if (!isOpen) return null;

  const handleClose = () => {
    if (isLoading) return;
    onClose();
  };

  const confirmClass =
    variant === "danger"
      ? "smrttasks-btn-save smrttasks-btn-danger-save"
      : variant === "warning"
        ? "smrttasks-btn-save smrttasks-btn-warning-save"
        : "smrttasks-btn-save";

  const busyLabel =
    variant === "danger" ? "Deleting..." : "Working...";

  return (
    <div className="smrttasks-modal-overlay" {...backdrop}>
      <div className="smrttasks-modal" onClick={(e) => e.stopPropagation()}>
        <div className="smrttasks-modal-header">
          <h2>{title}</h2>
        </div>
        <div className="smrttasks-modal-body">
          {error && <p className="smrttasks-modal-error">{error}</p>}
          <p
            style={{
              fontSize: "0.9rem",
              lineHeight: 1.5,
              margin: "0 0 16px",
              color: "#e5e5e5",
            }}
          >
            {message}
          </p>

          <div className="smrttasks-modal-actions">
            <button
              type="button"
              className="smrttasks-btn-cancel"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className={confirmClass}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? busyLabel : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
